import React, { useState } from 'react';
import { contactDetails, siteContent } from '../content/siteContent';

const Contact = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState('idle');

  const { contact } = siteContent;
  const formspreeId = process.env.REACT_APP_FORMSPREE_ID;

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  const onSubmit = async (event) => {
    event.preventDefault();

    if (!name.trim() || !isValidEmail(email) || !message.trim()) {
      setStatus('error');
      return;
    }

    setStatus('sending');

    if (formspreeId) {
      try {
        const response = await fetch(`https://formspree.io/f/${formspreeId}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ name, email, phone, message }),
        });

        if (response.ok) {
          setStatus('success');
          setName('');
          setEmail('');
          setPhone('');
          setMessage('');
          return;
        }
      } catch (_) {
        // Fall through to mailto fallback.
      }
    }

    const subject = encodeURIComponent(contactDetails.emailSubject);
    const body = encodeURIComponent(`Name: ${name}\nEmail: ${email}\nPhone: ${phone}\n\n${message}`);
    window.location.href = `${contactDetails.emailHref}?subject=${subject}&body=${body}`;
    setStatus('idle');
  };

  return (
    <section id="contact" className="contact" aria-labelledby="contact-heading">
      <div className="container">
        <h2 id="contact-heading">{contact.heading}</h2>
        <p className="lead">{contact.message}</p>

        <div className="contact-card surface-card">
          <div className="contact-actions">
            <a className="btn btn--primary" href={contactDetails.phoneHref}>{contact.callLabel}</a>
            <a className="btn btn--whatsapp" href={contactDetails.whatsappHref} target="_blank" rel="noopener noreferrer">{contact.whatsappLabel}</a>
            <a className="btn btn--secondary" href={`${contactDetails.emailHref}?subject=${encodeURIComponent(contactDetails.emailSubject)}`}>{contact.emailLabel}</a>
          </div>

          <form className="contact-form" onSubmit={onSubmit} noValidate>
            <div className="row">
              <label>
                {contact.form.nameLabel}
                <input type="text" value={name} onChange={(event) => setName(event.target.value)} required />
              </label>
              <label>
                {contact.form.emailLabel}
                <input type="email" value={email} onChange={(event) => setEmail(event.target.value)} required />
              </label>
            </div>
            <div className="row">
              <label>
                {contact.form.phoneLabel}
                <input type="tel" value={phone} onChange={(event) => setPhone(event.target.value)} />
              </label>
            </div>
            <label>
              {contact.form.messageLabel}
              <textarea rows="5" value={message} onChange={(event) => setMessage(event.target.value)} required />
            </label>
            <button type="submit" className="btn btn--primary" disabled={status === 'sending'}>
              {status === 'sending' ? contact.form.sendingLabel : contact.form.submitLabel}
            </button>
            <div aria-live="polite" aria-atomic="true">
              {status === 'sending' && <p className="form-note muted">{contact.form.sendingLabel}</p>}
              {status === 'success' && <p className="form-note success">{contact.form.success}</p>}
            </div>
            {status === 'error' && <p role="alert" className="form-note error">{contact.form.error}</p>}
            {!formspreeId && <p className="form-note muted">{contact.form.muted}</p>}
          </form>
        </div>
      </div>

      <div className="sticky-contact">
        <a href={contactDetails.phoneHref}>{contact.sticky.call}</a>
        <a href={`${contactDetails.emailHref}?subject=${encodeURIComponent(contactDetails.emailSubject)}`}>{contact.sticky.email}</a>
        <a href={contactDetails.whatsappHref} target="_blank" rel="noopener noreferrer">{contact.sticky.whatsapp}</a>
      </div>
    </section>
  );
};

export default Contact;
